import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "table"
};
var _hoisted_2 = {
  key: 0,
  class: "tac"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [$props.title ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString($props.title), 1)) : _createCommentVNode("", true), _createVNode(_component_el_table, {
    data: $props.tableData,
    border: "",
    style: {
      "width": "100%"
    },
    "max-height": "500px",
    "show-header": $props.isShowHeader,
    "row-key": $options.getRowKey,
    "cell-style": $options.cellStyle
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.header, function (value, key, index) {
        return _openBlock(), _createBlock(_component_el_table_column, {
          key: index,
          prop: key,
          label: value,
          align: "center"
        }, null, 8, ["prop", "label"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["data", "show-header", "row-key", "cell-style"])])]);
}